import React, { useState } from 'react';
import axios from 'axios';

export default function FiveDimensionPanel({ projectName }) {
  const [loading, setLoading] = useState(false);
  const [anatomy, setAnatomy] = useState(null);

  const runDeconstruct = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/projects/${encodeURIComponent(projectName)}/deconstruct`);
      setAnatomy(res.data);
    } catch (err) {
      setAnatomy({
        project: projectName,
        status: 'frontend-placeholder',
        message: '五维解构接口暂未接通，前台驾驶舱已就位',
        constitution: {
          immutable: '不易：目标、边界、价值导向、验收标准',
          change: '变易：流程、状态、数据、业务变化',
          simplicity: '简易：构建、测试、部署、回滚、交付'
        },
        fiveDimensions: {
          target: '目标维度：软件为什么存在，谁受益，成功标准是什么',
          process: '流程维度：核心业务流程是否闭环',
          data: '数据维度：实体、关系、生命周期是否清晰',
          tools: '工具维度：依赖、接口、运行环境、部署工具是否可控',
          output: '输出维度：页面、API、报告、部署包是否可验收'
        },
        vitality: {
          BDI: '模块与验收覆盖广度',
          MCR: '失败经验回灌率',
          AT: '异常恢复能力',
          SR: '从失败到新稳态的速度'
        },
        error: err.response?.data?.error || err.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 text-sm">
      <h3 className="font-bold mb-3">五维解构</h3>

      <div className="bg-gray-900 rounded p-3 mb-3 text-xs text-gray-300 leading-6">
        <p>最高原则：易传五维是宪法，AI只是评审员。</p>
        <p>执行顺序：诊断 → 折叠 → 返回 → 补丁 → 回归。</p>
      </div>

      <button
        onClick={runDeconstruct}
        disabled={loading}
        className="w-full bg-cyan-600 hover:bg-cyan-700 disabled:opacity-60 py-2 rounded mb-4"
      >
        {loading ? '解构中...' : '执行五维解构'}
      </button>

      <pre className="bg-black text-cyan-300 p-3 rounded h-96 overflow-auto text-xs whitespace-pre-wrap">
        {JSON.stringify(anatomy || {
          waiting: true,
          project: projectName,
          next: '点击“执行五维解构”，生成 system-anatomy 与项目宪法检查结果'
        }, null, 2)}
      </pre>
    </div>
  );
}
